import { useState } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";
import { Lock } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const expired = new URLSearchParams(location.search).get("expired") === "1";

  if (user) return <Navigate to="/strefa" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(form.username, form.password);
      navigate("/strefa");
    } catch (e2) {
      setError(formatErr(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16" data-testid="login-page">
      <SectionHeader title="Logowanie" />
      <p className="text-center mt-6 mb-10 text-sm" style={{ color: "var(--sr-muted)" }}>
        Strefa członków klubu.
      </p>
      {expired && (
        <div
          className="mb-6 p-4 text-sm text-center"
          style={{ background: "rgba(255,106,26,0.12)", border: "1px solid var(--sr-fire)", color: "var(--sr-fire-2)" }}
          data-testid="session-expired-banner"
        >
          Twoja sesja wygasła lub konto zostało usunięte. Zaloguj się ponownie.
        </div>
      )}
      <form onSubmit={submit} className="sr-card p-8 fade-up" data-testid="login-form">
        <div className="flex justify-center mb-6">
          <div className="p-3 border-2 border-[var(--sr-fire)] rounded-full">
            <Lock className="text-[var(--sr-fire)]" size={24} />
          </div>
        </div>
        <div className="mb-5">
          <label className="sr-label">Nazwa użytkownika</label>
          <input
            type="text"
            required
            autoFocus
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            className="sr-input"
            data-testid="login-username"
          />
        </div>
        <div className="mb-6">
          <label className="sr-label">Hasło</label>
          <input
            type="password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="sr-input"
            data-testid="login-password"
          />
        </div>
        {error && <p className="text-sm mb-4 text-red-400" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-fire w-full" data-testid="login-submit">
          {loading ? "Logowanie..." : "Zaloguj się"}
        </button>
        <p className="text-xs text-center mt-6" style={{ color: "var(--sr-muted)" }}>
          Nie masz konta? Skontaktuj się z administratorem klubu.
        </p>
      </form>
    </div>
  );
}
